import { render, staticRenderFns } from "./tours-data-table.vue?vue&type=template&id=7f4c735c&"
import script from "./tours-data-table.vue?vue&type=script&lang=js&"
export * from "./tours-data-table.vue?vue&type=script&lang=js&"
import style0 from "./tours-data-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tours-data-table.vue"
export default component.exports